module.exports = __webpack_public_path__ + "static/media/educational-resource.0de15261.svg";